var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$store.getters.classData.Name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }